// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_19JsHrno9dB61regZ30qgF","spaceLeft":"_3v5dq99ihbxDqKqSK42jKI","spaceBoth":"_34QQyHmfYfvjun7KqgpcxS","spaceRight":"eGf3EuC1EF9qGeb10Q4-C","container":"apxl6rO8k0sQqQ3YfspVR","row":"_3GUV89b3TqdbkWDNWt5WqO","recipientAddress":"_2bpASFaTlpQru2pC924A_F","frame":"_3uwupSKyWlEaRP1dQfEIQo","table":"_3y1fsMjEyg3FsOnJ62idpH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenTransferHistory.scss
// module id = 1274
// module chunks = 0